import { fractionMap } from "./types";

export const FRACTION_DICTIONARY: fractionMap = {
  0.25: 188,
  0.5: 189,
  0.75: 190,
  0.33: 8531,
  0.66: 8532,
  0.2: 8533,
  0.4: 8534,
  0.6: 8535,
  0.8: 8536,
  0.16: 8537,
  0.83: 8538,
  0.125: 8539,
  0.375: 8540,
  0.625: 8541,
  0.875: 8542,
};

export const MAX_MOBILE_WIDTH_PX = 1024;
